import { ProductTagBase } from '../ProductTagBase';
import klass from '../style/ProductTag.module.scss';
import { ProductTimeHelper } from '../../ProductCard/utils/ProductTimeHelper';
import { type Html } from 'rune-ts';
import { LiveIcon } from '../../../atoms/Icon';

/**
 * @figma
 * https://www.figma.com/design/Top00pi5q5ylSxEviOOciV/MarppleShop-Design-System?node-id=21842-60147&m=dev
 */
export class RealtimeTag extends ProductTagBase<Date> {
  protected makeLabel(): string | undefined {
    const diff = ProductTimeHelper.diffDate(new Date(), new Date(this.data.value));
    return ET('mps2::product::tag::realtime', {
      lng: this.data.lang,
      time: ProductTimeHelper.formatDiff(diff),
    });
  }

  protected styles(): string {
    return klass.realtime;
  }

  isTimerNeeded(): boolean {
    return true;
  }

  override getIcon(): Html {
    return LiveIcon;
  }
}
